import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const meetingManagement = createApi({
    reducerPath: "meetingManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        participantsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/users`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        meetingParticipants: builder.mutation({
            query: (meetingId) => ({
                url: `v1/${locale}/meetings/${meetingId}/participants`,
                method: "GET",
            }),
        }),
        viewMeeting: builder.mutation({
            query: (meetingId) => ({
                url: `v1/${locale}/meetings/${meetingId}`,
                method: "GET",
            }),
        }),
        addMeeting: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/meetings`,
                method: "POST",
                body: body,
            }),
        }),
        updateMeeting: builder.mutation({
            query: ({body, meetingId}) => ({
                url: `v1/${locale}/meetings/${meetingId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteMeeting: builder.mutation({
            query: (meetingId) => ({
                url: `v1/${locale}/meetings/${meetingId}`,
                method: "DELETE",
            }),
        }),
        cancelMeeting: builder.mutation({
            query: ({meetingId}) => ({
                url: `v1/${locale}/meetings/${meetingId}/cancel`,
                method: "PATCH",
            }),
        }),
        addParticipants: builder.mutation({
            query: ({meetingId, participantId }) => ({
                url: `v1/${locale}/meetings/${meetingId}/participants/${participantId}`,
                method: "POST",
            }),
        }),
        deleteParticipants: builder.mutation({
            query: ({meetingId, participantId }) => ({
                url: `v1/${locale}/meetings/${meetingId}/participants/${participantId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { 
    useParticipantsListMutation, 
    useMeetingParticipantsMutation,
    useAddMeetingMutation,
    useUpdateMeetingMutation,
    useViewMeetingMutation,
    useDeleteMeetingMutation,
    useAddParticipantsMutation,
    useDeleteParticipantsMutation,
    useCancelMeetingMutation
} = meetingManagement;
